import { FC, useState, useEffect, useRef } from 'react';
import {
    Box,
    Avatar,
    Divider,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Checkbox,
    ListItemText,
    Tooltip,
    IconButton,
} from '@mui/material';
import { SCUIGeneralModal, SCUIReturnProductCopyButton } from '../../../../../atomic/molecules';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import Helper from '../../../../../utils/helper';
import { ReturnQuery } from '../../../../../services/query';

export const SCUIReturnDetailModalApprove: FC<{
    disableAprroveProduct: any;
    product: any;
    open: any;
    onClose?: any;
    returnData: any;
    returnReason: any;
    returnRejectedReason: any;
    formattedCreateConfirm?: any;
    scannedBarcodeForModal?: any;
    selectedQrCodes?: any;
    setSelectedQrCodes?: any;
}> = ({
    disableAprroveProduct,
    product,
    open,
    onClose,
    returnData,
    returnReason,
    returnRejectedReason,
    formattedCreateConfirm,
    scannedBarcodeForModal,
    selectedQrCodes,
    setSelectedQrCodes,
}) => {
    const [rejectReason, setRejectReason] = useState(0);
    const [nonRestockQuantityState, setNonRestockQuantityState] = useState(0);
    const [rejectedQuantityState, setRejectedQuantityState] = useState(0);
    const [restockQuantityState, setRestockQuantityState] = useState(1);
    const [operatorReturnReasonId, setOperatorReturnReasonId] = useState(product.reason);
    const [countryIsActive, setCountryIsActive] = useState<boolean>();
    const [tempQrCodes, setTempQrCodes] = useState<string[]>([]);
    const productInfoRef = useRef<HTMLDivElement>(null);

    const storeCode = Helper.getStoreCode();
    let showRejectedStatus = storeCode && !returnData?.showReturnRejectedFromRule;
    let showQrCodeEnabled = returnData?.showQrCodeFromRule;

    const { t } = useTranslation();

    const returnRejectedReasonData = [{ reasonId: 0, reasonName: t('general.none') }, ...returnRejectedReason];

    const handleReasonDesc = (event: any) => {
        setOperatorReturnReasonId(Number(event.target.value));
    };
    const handleRejectReason = (event: any) => {
        setRejectReason(Number(event.target.value));
    };

    let quantityForSelectBox: any = [];
    for (let i = 0; i <= product.piece; i++) {
        quantityForSelectBox.push(<MenuItem value={i}>{i}</MenuItem>);
    }

    let quantityForSelectBoxRejected: any = [];
    for (let i = 0; i <= product.piece; i++) {
        quantityForSelectBoxRejected.push(<MenuItem value={i}>{i}</MenuItem>);
    }

    const formatDataForAPI = () => {
        const qrCodeListModelValue =
            tempQrCodes && tempQrCodes.length > 0 ? tempQrCodes.map((qrCode: string) => ({ qrCode })) : undefined;

        const obj = {
            returnItemId: product.returnItemId,
            productId: product.productId,
            barcode: scannedBarcodeForModal || product.barcode,
            shippingListId: product.shippingListId,
            quantity: product.piece,
            restockQuantity: restockQuantityState,
            nonRestockQuantity: nonRestockQuantityState,
            rejectedQuantity: rejectedQuantityState,
            rejectedReason: rejectedQuantityState === 0 ? 0 : rejectReason,
            operatorReturnReasonId: operatorReturnReasonId,
            statusId: product.status,
            qrCodeListModel: qrCodeListModelValue,
        };
        return obj;
    };

    const validateForm = () => {
        if (rejectedQuantityState > 0 && rejectReason === 0) {
            Swal.fire(t('return.rejectReasonSelect'), ' ', 'error');
            return false;
        }

        if (
            Number(nonRestockQuantityState) + Number(restockQuantityState) + Number(rejectedQuantityState) >
            Number(product.piece)
        ) {
            Swal.fire(t('general.cannotAcceptExcessProducts'), ' ', 'error');
            return false;
        }

        // QR Kod validasyonu: Satılabilir ve satılamaz ürün adet sayısı toplamı kadar QR Kod seçilmeli
        if (product?.qrCodeListModel && product.qrCodeListModel.length > 0) {
            const restockQuantity = Number(restockQuantityState);
            const nonRestockQuantity = Number(nonRestockQuantityState);
            const totalQuantity = restockQuantity + nonRestockQuantity;
            if (tempQrCodes.length !== totalQuantity) {
                Swal.fire(t('general.error'), t('return.qrCodeSelectionRequired'), 'error');
                return false;
            }
        }

        return true;
    };

    // QR Kod validasyonu kontrolü - Kaydet butonunun disabled olması için
    const isQrCodeValid = () => {
        if (product?.qrCodeListModel && product.qrCodeListModel.length > 0) {
            const restockQuantity = Number(restockQuantityState);
            const nonRestockQuantity = Number(nonRestockQuantityState);
            const totalQuantity = restockQuantity + nonRestockQuantity;
            return tempQrCodes.length === totalQuantity;
        }
        return true; // QR kod yoksa validasyon gerekmez
    };

    const formatla = (closePopup: any) => {
        if (!validateForm()) {
            return;
        }

        const dataForAPI = formatDataForAPI();
        formattedCreateConfirm(dataForAPI);

        const existingQrCodes = selectedQrCodes[product.barcode] || [];
        setSelectedQrCodes({ ...selectedQrCodes, [product.barcode]: [...existingQrCodes, ...tempQrCodes] });
        setTempQrCodes([]);
        if (closePopup) {
            onClose();
        }
    };
    const GetReturnRejectReturnRejectCountryActiveListByRule = () => {
        ReturnQuery.GetReturnRejectReturnRejectCountryActiveListByRule()
            .then((res: any) => {
                if (res) {
                    setCountryIsActive(res);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    useEffect(() => {
        GetReturnRejectReturnRejectCountryActiveListByRule();
        const handleKeyPress = (event: any) => {
            if (event.keyCode === 13) {
                setTimeout(function () {
                    formatla(false);
                }, 1000); // tüm işlemler bitince enter tuşuna basınca completeconfirmi çağırır
            }
        };

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, []);
    useEffect(() => {
        if (disableAprroveProduct) {
            setRejectedQuantityState(1);
            setNonRestockQuantityState(0);
            setRestockQuantityState(0);
            setRejectReason(11);
        } else {
            setRejectedQuantityState(0);
            setNonRestockQuantityState(0);
            setRestockQuantityState(1);
            setRejectReason(0);
        }

        setOperatorReturnReasonId(product.reason);
    }, [product, disableAprroveProduct]);

    // Modal kapandığında seçili QR kodlarını temizle
    useEffect(() => {
        if (!open && product?.barcode) {
            setTempQrCodes([]);
        }
    }, [open, product?.barcode]);

    return (
        <SCUIGeneralModal
            autoFocusButton={true}
            open={open}
            onClose={onClose}
            width={'sm'}
            sx={{
                '& .MuiDialogTitle-root': {
                    fontSize: '16px !important',
                    fontWeight: '700',
                    padding: '0 !important',
                },
                '& .MuiDialog-paper': {
                    padding: '24px',
                },
            }}
            title={t('general.productApproval')}
            functionButtonOnClick={formatla}
            buttonText={t('general.save')}
            disabled={!isQrCodeValid()}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <p style={{ fontSize: '16px', fontWeight: '700' }}>{t('return.productInfo')}</p>
                    <SCUIReturnProductCopyButton product={product} imageUrl={product.productImageUrl} />
                </Box>
                <Box ref={productInfoRef} sx={{ padding: '1rem', display: 'flex', flexDirection: 'row' }}>
                    <Box sx={{ marginRight: '16px' }}>
                        <Avatar
                            sx={{
                                width: 128,
                                height: 128,
                                display: 'inline-block',
                                verticalAlign: 'top',
                                '& .MuiAvatar-img': {
                                    objectFit: 'contain !important',
                                },
                            }}
                            variant="square"
                            src={product.productImageUrl}
                        />
                    </Box>
                    <Box>
                        <p style={{ fontSize: '14px', fontWeight: '700' }}>{t('general.returnReason')}</p>
                        {product.reason === 15 ||
                        product.reason === 9 ||
                        product.reason === 3 ||
                        product.reason === 44 ? (
                            <p
                                style={{
                                    fontSize: '14px',
                                    fontWeight: '700',
                                    backgroundColor: 'red',
                                    paddingLeft: '2px',
                                }}
                            >
                                {product.reasonDescription}
                            </p>
                        ) : (
                            <p style={{ fontSize: '14px', fontWeight: '400' }}>{product.reasonDescription}</p>
                        )}
                        <p style={{ fontSize: '14px', fontWeight: '700', marginTop: '6px' }}>
                            {t('general.productName')}
                        </p>
                        <p style={{ fontSize: '14px', fontWeight: '400' }}>{product.productDescriptionOnWebSite}</p>
                        <p style={{ fontSize: '14px', fontWeight: '700', marginTop: '6px' }}>
                            {t('general.productSize')}
                        </p>
                        <p style={{ fontSize: '14px', fontWeight: '400' }}>{product.size}</p>
                    </Box>
                    <Box sx={{ marginLeft: '24px' }}>
                        <p style={{ fontSize: '14px', fontWeight: '700' }}> {t('general.barcode')}</p>
                        <p style={{ fontSize: '14px', fontWeight: '400' }}>{product.barcode}</p>
                        <p style={{ fontSize: '14px', fontWeight: '700', marginTop: '6px' }}>
                            {t('general.specialCode')}
                        </p>
                        <p style={{ fontSize: '14px', fontWeight: '400' }}>
                            {product.ozelKod1} - {product.renkKod}
                        </p>
                        <p style={{ fontSize: '14px', fontWeight: '700', marginTop: '6px' }}>
                            {t('general.brandName')}
                        </p>
                        <p style={{ fontSize: '14px', fontWeight: '400' }}>{product.brandName}</p>
                    </Box>
                </Box>
                <Divider sx={{ paddingTop: 2, marginBottom: 2, width: '100%' }} />
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            width: !showRejectedStatus && countryIsActive ? '48%' : '100%',
                            flexDirection: 'column',
                            padding: '16px',
                            border: '1px solid green',
                            borderRadius: '8px',
                        }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <CheckCircleOutlineIcon
                                sx={{ width: '20px', height: '20px', marginRight: '8px' }}
                                color="success"
                            />
                            <p style={{ fontSize: '16px', fontWeight: '700' }}>{t('return.returnAccept')}</p>
                        </Box>
                        <Box sx={{ marginTop: '16px' }}>
                            <FormControl fullWidth>
                                <InputLabel>{t('general.restockQuantity')}</InputLabel>
                                <Select
                                    disabled={
                                        !product.isReturnable ||
                                        (returnData.returnPlatformTypeId === 9 && returnData.isMarketPlaceReturn)
                                    }
                                    fullWidth
                                    label={t('general.restockQuantity')}
                                    value={restockQuantityState}
                                    onChange={(event) => {
                                        setRestockQuantityState(Number(event.target.value));
                                    }}
                                >
                                    {quantityForSelectBox}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box sx={{ marginTop: '16px' }}>
                            <FormControl fullWidth>
                                <InputLabel>{t('general.nonRestockQuantity')}</InputLabel>
                                <Select
                                    disabled={
                                        !product.isReturnable ||
                                        (returnData.returnPlatformTypeId === 9 && returnData.isMarketPlaceReturn)
                                    }
                                    fullWidth
                                    label={t('general.nonRestockQuantity')}
                                    value={nonRestockQuantityState}
                                    onChange={(event) => {
                                        // satılamaz üründe de sıfırlansın istediler
                                        setRestockQuantityState(0);
                                        setRejectedQuantityState(0);
                                        setNonRestockQuantityState(Number(event.target.value));
                                    }}
                                >
                                    {quantityForSelectBox}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box sx={{ marginTop: '16px' }}>
                            <FormControl fullWidth>
                                <InputLabel>{t('general.operatorReturnReason')}</InputLabel>
                                <Select
                                    disabled={
                                        !product.isReturnable ||
                                        (returnData.returnPlatformTypeId === 9 && returnData.isMarketPlaceReturn)
                                    }
                                    fullWidth
                                    label={t('general.operatorReturnReason')}
                                    onChange={(event) => {
                                        handleReasonDesc(event);
                                    }}
                                    value={operatorReturnReasonId}
                                >
                                    {returnReason &&
                                        returnReason.map((item: any, index: number) => (
                                            <MenuItem key={index} id={item.returnReasonId} value={item.returnReasonId}>
                                                {item.reasonName}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Box>
                        {product?.qrCodeListModel && product.qrCodeListModel.length > 0 && showQrCodeEnabled && (
                            <Box sx={{ marginTop: '16px', display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                                <Tooltip title={t('return.qrCodeSelectionRequired')} arrow placement="top">
                                    <IconButton size="small" sx={{ mt: 1, color: 'primary.main' }}>
                                        <InfoIcon />
                                    </IconButton>
                                </Tooltip>
                                <FormControl fullWidth>
                                    <InputLabel>{t('general.qrCode')}</InputLabel>
                                    <Select
                                        multiple
                                        disabled={
                                            !product.isReturnable ||
                                            (returnData.returnPlatformTypeId === 9 && returnData.isMarketPlaceReturn)
                                        }
                                        fullWidth
                                        label={t('general.qrCode')}
                                        value={tempQrCodes}
                                        onChange={(event) => {
                                            const value = event.target.value;
                                            setTempQrCodes(typeof value === 'string' ? value.split(',') : value);
                                        }}
                                        renderValue={(selected) => selected.join(', ')}
                                    >
                                        {product.qrCodeListModel.map((qrCode: any, index: number) => {
                                            const qrCodeValue = qrCode.qrCode || qrCode;
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    value={qrCodeValue}
                                                    disabled={(selectedQrCodes?.[product.barcode] || []).includes(
                                                        qrCodeValue
                                                    )}
                                                >
                                                    <Checkbox checked={(tempQrCodes || []).includes(qrCodeValue)} />
                                                    <ListItemText primary={qrCodeValue} />
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Box>
                        )}
                    </Box>
                    {!showRejectedStatus && countryIsActive && (
                        <Box
                            sx={{
                                marginLeft: '16px',
                                width: '48%',
                                padding: '16px',
                                border: '1px solid red',
                                borderRadius: '8px',
                            }}
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <HighlightOffIcon
                                    sx={{ width: '20px', height: '20px', marginRight: '8px' }}
                                    color="error"
                                />
                                <p style={{ fontSize: '16px', fontWeight: '700' }}>{t('return.returnRejectionList')}</p>
                            </Box>
                            <Box sx={{ marginTop: '16px' }}>
                                <FormControl fullWidth>
                                    <InputLabel id="statusSelectLabel">{t('general.rejectedQuantity')}</InputLabel>
                                    <Select
                                        labelId="statusSelectLabel"
                                        fullWidth
                                        label={t('general.rejectedQuantity')}
                                        value={rejectedQuantityState}
                                        onChange={(event) => {
                                            //reddilen üründe satılabilir satılamaz sıfırlansın istediler
                                            setRejectedQuantityState(Number(event.target.value));
                                            setNonRestockQuantityState(0);
                                            setRestockQuantityState(0);
                                        }}
                                    >
                                        {quantityForSelectBoxRejected}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box sx={{ marginTop: '16px' }}>
                                <FormControl fullWidth>
                                    <InputLabel>{t('return.rejectReasonSelect')}</InputLabel>
                                    <Select
                                        fullWidth
                                        label={t('return.rejectReasonSelect')}
                                        onChange={(event) => {
                                            handleRejectReason(event);
                                        }}
                                        value={rejectReason}
                                    >
                                        {returnRejectedReasonData &&
                                            returnRejectedReasonData.map((item: any, index: number) => (
                                                <MenuItem key={index} id={item.reasonId} value={item.reasonId}>
                                                    {item.reasonName}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box>
                    )}
                </Box>
                <Divider sx={{ paddingTop: 2, width: '100%' }} />
            </Box>
        </SCUIGeneralModal>
    );
};
